export default "/_next/static/images/Falco_logo_icon_white-f1ab1752640755104e7dbb48c2eafe67.png";